import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
export const CustomerManagementUseCardOnFileSettings = ProtoBaseModel.extend({
  showSaveCardAfterCheckout: attr(Boolean),
  cardOnFileEnabled: attr(Boolean)
});
export default ProtoBaseModel.extend({
  collectBeforeCheckout: attr(Boolean),
  collectAfterCheckout: attr(Boolean),
  useCardOnFile: attr(CustomerManagementUseCardOnFileSettings),
  showAddCustomerCartRow: attr(Boolean),
  showEmailCollectionScreen: attr(Boolean),
  displayValueTranslationKey: computed('collectAfterCheckout', 'collectBeforeCheckout', function () {
    return this.collectBeforeCheckout || this.collectAfterCheckout ? 'business.devices.profiles.v2.settings.checkout.customerManagement.displayValue.on' : 'business.devices.profiles.v2.settings.checkout.customerManagement.displayValue.off';
  })
});